<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>{{ title }}</h3>
            </div>
        </div>
        <div class="card mb-3">
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12">
                        <img width="100%" :src="src" :alt="src">
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button @click="cerrar" class="btn-danger btn--text"><span>{{ $t('message.cerrar') }}</span></button>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        title : {
            type : String,
            required : true
        },
        src : {
            type : String,
            required : true
        }
    },
    methods : {
        cerrar : function () {
            this.$emit('cerrar');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/clientes/VisorImagen.vue